export class Exception extends Error {
  constructor(message) {
    super(message);
  }
}
